import { FC } from "react";

interface BFLIconProps {
  className: string;
  size?: string;
  style?: Record<string, string>;
}
const BFLIcon: FC<BFLIconProps> = ({ className, style, size = "24px" }) => {
  return <i className={`icomoon ${className} text-[${size}]`} style={style}></i>;
};

export default BFLIcon;
